<script setup lang="ts">
import {Component} from "../types.ts";
import {onMounted, watch} from "vue";
import useStore from "../store.ts";
import {updateTimerHidden} from "../utils/ElementUtils.ts";

const props = defineProps<{
  item: Component
}>();

const store = useStore();

// see docs/EXTRACTED_COMMENTS.md#c777
const evaluate = () => updateTimerHidden(props.item.props.id, Math.floor(store.currentDate / 1000));

watch(() => Math.floor(store.currentDate / 1000), evaluate);

onMounted(evaluate);
</script>

<template>
  <div v-bind="item.props">
    <slot>
    </slot>
  </div>
</template>

<style scoped>

</style>
